import type { Edge, Node } from 'reactflow'

export type AssetNodeData = {
  groupId?: string
  connectorId?: string
  label?: string
  titleLine?: string
  integrationResult?: boolean
}

export function getNodeGroupId(node: Node): string | undefined {
  const data = node.data as AssetNodeData | undefined
  return data?.groupId
}

export function getUpstreamSourceNodeIds(
  integrationNodeId: string,
  nodes: Node[],
  edges: Edge[]
): string[] {
  const byId = new Map(nodes.map(n => [n.id, n]))
  const incoming = edges.filter(e => e.target === integrationNodeId)
  const sources = incoming
    .map(e => byId.get(e.source))
    .filter((n): n is Node => !!n)
    .filter(n => getNodeGroupId(n) === 'sources')
  return [...sources].sort((a, b) => a.position.x - b.position.x).map(n => n.id)
}
